import React from 'react';

const Dashboard = () => {
    return (
        <div>
            <h1>This is Dashboard Area</h1>
        </div>
    );
};

export default Dashboard;